import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mergeClassNames from 'merge-class-names';
import { tileProps } from './shared/propTypes.js';
import { IndicatorWrapper, Indicator } from '../Indicators.js';

function getValue(nextProps, prop) {
  const {
    activeStartDate,
    date,
    view
  } = nextProps;
  return typeof prop === 'function' ? prop({
    activeStartDate,
    date,
    view
  }) : prop;
}
class Tile extends Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      tileClassName,
      tileContent
    } = nextProps;
    const nextState = {};
    if (tileClassName !== prevState.tileClassNameProps) {
      nextState.tileClassName = getValue(nextProps, tileClassName);
      nextState.tileClassNameProps = tileClassName;
    }
    if (tileContent !== prevState.tileContentProps) {
      nextState.tileContent = getValue(nextProps, tileContent);
      nextState.tileContentProps = tileContent;
    }
    return nextState;
  }
  render() {
    const {
      activeStartDate,
      children,
      classes,
      date,
      formatAbbr,
      locale,
      maxDate,
      maxDateTransform,
      minDate,
      minDateTransform,
      onClick,
      onMouseOver,
      style,
      tileDisabled,
      view,
      tabIndex,
      value,
      isNeighboringMonth,
      indicators,
      surface
    } = this.props;
    const {
      tileClassName,
      tileContent
    } = this.state;
    const isSelected = date && value && date.toDateString() === value.toDateString();
    const isDisabled = minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
      activeStartDate,
      date,
      view
    });
    formatAbbr ? isSelected ? `${formatAbbr(locale, date)} selected` : formatAbbr(locale, date) : undefined;
    const filteredIndicators = indicators && indicators.filter(data => data.date && data.date.getTime() === date.getTime());
    const getAriaLabel = () => {
      if (formatAbbr) {
        let ariaLabel = formatAbbr(locale, date);
        if (isSelected) {
          ariaLabel = `${ariaLabel} selected`;
        }
        if (filteredIndicators && filteredIndicators.length >= 1) {
          filteredIndicators.forEach(data => {
            ariaLabel = `${ariaLabel} ${data.label}`;
          });
        }
        return ariaLabel;
      }
      return undefined;
    };
    return React.createElement("button", {
      className: mergeClassNames(classes, tileClassName),
      disabled: isDisabled,
      onClick: onClick && (event => onClick(date, event)),
      onFocus: onMouseOver && (() => onMouseOver(date)),
      onMouseOver: onMouseOver && (() => onMouseOver(date)),
      style: style,
      type: "button",
      tabIndex: tabIndex,
      "aria-label": getAriaLabel(),
      "aria-hidden": isDisabled || isNeighboringMonth
    }, formatAbbr ? React.createElement("abbr", {
      "aria-label": getAriaLabel()
    }, children) : children, tileContent, formatAbbr && filteredIndicators && filteredIndicators.length >= 1 && React.createElement(IndicatorWrapper, null, indicators.map((data, index) => {
      return data.date && data.date.getTime() === date.getTime() && React.createElement(Indicator, {
        key: index,
        type: index + 1,
        surface: surface || isSelected && !isDisabled,
        isSelected: isSelected
      });
    })));
  }
}
Tile.propTypes = Object.assign(Object.assign({}, tileProps), {
  children: PropTypes.node.isRequired,
  formatAbbr: PropTypes.func,
  maxDateTransform: PropTypes.func.isRequired,
  minDateTransform: PropTypes.func.isRequired
});

export { Tile as default };
